import { ExperienceCategory } from "modules/PsyCatalog/common/ExperienceCategory"

export function getSessionCountEmoji(category: ExperienceCategory) {
    const sessionCount = Number(ExperienceCategory[category])
    if (sessionCount >= 1000) return "rocket-emoji.png"
    if (sessionCount >= 500) return "fire-emoji.png"
    return "raised-hands-emoji.png"
}
